<script>
	import { logout } from "../../scripts/logout";

	import { profileData } from "../../stores/data";

	let userData = {
		name: "Пользователь",
	};

	$profileData.label && (userData.name = $profileData.label);
	+$profileData.Image && (userData.img = $profileData.Image);

	let user_menu_active;
	let user_menu;

	function openUserInfo() {
		user_menu_active = !user_menu_active;
		if (user_menu_active) {
			user_menu.style.transform =
				"translateY(" + user_menu.scrollHeight + "px)";
			document.addEventListener("click", temp);
		} else {
			user_menu.style.transform = null;
		}

		let container = this.parentNode;
		function temp(e) {
			if (e.target.parentNode != container) {
				document.removeEventListener("click", temp);
				user_menu_active = false;
				user_menu.style.transform = null;
			}
		}
	}
</script>

{#if userData}
	<div class="user">
		<div class="user__content" on:click={openUserInfo}>
			<div class="user__name">
				<span>{userData.name}</span>
			</div>
			<div class="user__logo">
				<img
					src={userData.img ? userData.img : "/img/user.svg"}
					alt=""
				/>
			</div>
		</div>
		<div
			class="user__menu"
			class:selected={user_menu_active}
			bind:this={user_menu}
		>
			<span
				on:click={() => {
					logout("exit");
				}}>Выход</span
			>
		</div>
	</div>
{/if}

<style lang="scss">
	.user {
		display: flex;
		align-items: center;

		position: relative;

		&:hover {
			.user {
				&__menu:not(.selected) {
					transform: translateY(20px);
				}
			}
		}

		&__content {
			display: flex;
			align-items: center;
			cursor: pointer;
			padding: 12px 24px 11px;
			min-width: 200px;
			background: var(--bg-main-1);
			z-index: 2;
			height: 63px;
			> * {
				pointer-events: none;
			}
		}

		&__name {
			margin: 0 8px 0 auto;
		}

		&__logo {
			height: 48px;
			width: 48px;
			display: flex;
			flex-shrink: 0;
			border-radius: 50%;
			overflow: hidden;
			> img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}

		&__menu {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 1;
			display: flex;
			padding: 18px 0;
			background: var(--bg-main-1);
			border-bottom: 1px solid var(--border-gray-1);
			transition: all 0.2s;

			&.selected {
				box-shadow: 4px 4px 8px 0px #223c5033;
			}

			> span {
				padding: 5px 16px;
				cursor: pointer;
				width: 100%;

				&:hover {
					color: var(--color-1);
				}
			}
		}
	}
</style>
